import * as React from 'react';
import staticContent from '../data/content.json';

const ContentfulContext = React.createContext(null);

// Static form fields (kept for reference, also included in content.json)
const states = ['AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];

const form = [
    {
      label: "First Name",
      name: "firstName",
      type: "text",
      placeholder: "First Name",
      required: true
    },
    {
      label: "Last Name",
      name: "lastName",
      type: "text",
      placeholder: "Last Name",
      required: true
    },
    {
      label: "Email",
      name: "email",
      type: "email",
      placeholder: "Email",
      required: true
    },
    {
      label: "Phone Number",
      name: "phone",
      type: "tel",
      placeholder: "Phone",
      required: true
    },
    {
      label: "Interest Profile",
      name: "interestProfile",
      type: "select",
      placeholder: "Please select the profile that best matches your interest",
      options: [
        "Builder",
        "Architect",
        "Investor",
        "Homeowner"
      ],
      required: true
    },
    {
      label: "Please describe your interest",
      name: "description",
      type: "textarea",
      placeholder: "I would like...",
      required: true
    },
    {
      label: "Build State",
      name: "buildState",
      type: "select",
      placeholder: "Please Select",
      options: [
        ...states
      ]
    },
    {
      label: "Build Date",
      name: "buildDate",
      type: "date",
      placeholder: "Select a date"
    }
  ];


function ContentProvider({ children }){
    // Use static content directly - no API calls needed!
    // Content is exported at build time via: npm run export-content
    const content = React.useMemo(() => ({
      home: staticContent.home || [],
      story: staticContent.story || [],
      product: staticContent.product || [],
      features: staticContent.features || [],
      mediaFeatures: staticContent.mediaFeatures || [],
      hero: staticContent.hero || [],
      footer: staticContent.footer || [],
      images: staticContent.images || [],
      models: staticContent.models || [],
      faqs: staticContent.faqs || [],
      phases: staticContent.phases || [],
      profiles: staticContent.profiles || [],
      fields: form
    }), []);

    return <ContentfulContext.Provider value={content}>{children}</ContentfulContext.Provider>
}

function useContentful(){
    const context = React.useContext(ContentfulContext);
    if (context === undefined) {
        throw new Error('useContentful must be used within a ContentProvider')
    }
    return context    
}


export { ContentProvider, useContentful }
